import { loadTypes } from "./combination.class";
import { seismicParams, displacementTypes, seismicPerformanceTypes } from "./seismic.class";
import { fireDurations, fireParams } from "./fire.class";

export default {
    [loadTypes.STANDARD]:{
        isSustained: false,
        Nz: 0,
        Mx: 0,
        My: 0
    },
    [loadTypes.SEISMIC]:{
        [seismicParams.SEISMICITY_LEVEL]: "0",
        [seismicParams.BUILDING_IMPORTANCE_CLASS]: null,
        [seismicParams.CONNECTIONS]: null,
        [seismicParams.SEISMIC_PERFORMANCE]: seismicPerformanceTypes.C1,
        [seismicParams.DESIGN_OPTION]: null,
        [seismicParams.DESIGN_AGAINST_NONDUCTILE]: null,
        [seismicParams.DESIGN_AGAINST_PREMATURE]: null,
        [seismicParams.FILLED_HOLES]: false,
        [seismicParams.DISPLACEMENT]: displacementTypes.ETA,
        [seismicParams.DISPLACEMENT_VALUE_TENSION]: null,
        [seismicParams.DISPLACEMENT_VALUE_SHEAR]: null,
    },
    [loadTypes.FIRE]:{
        [fireParams.DURATION]: fireDurations.THIRTY,
        [fireParams.SIDE]: "0"
    }
};



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/DesignLoading/misc/defaultExtraField.js